import {
  FETCH_USER_MODULE_DETAILS_REQUEST,
  FETCH_USER_MODULE_DETAILS_SUCCESS,
  FETCH_USER_MODULE_DETAILS_FAILURE,
} from '../../../../Constants/actionTypes';

import { fetchUserModuleDetails } from '../../../../Constants/apiService';

export const fetchUserModuleDetailsRequest = () => ({ type: FETCH_USER_MODULE_DETAILS_REQUEST });
export const fetchUserModuleDetailsSuccess = (data) => ({ type: FETCH_USER_MODULE_DETAILS_SUCCESS, payload: data });
export const fetchUserModuleDetailsFailure = (error) => ({ type: FETCH_USER_MODULE_DETAILS_FAILURE, payload: error });

export const fetchUserModuleDetailsAct = () => {
  return async (dispatch, getState) => {
    dispatch(fetchUserModuleDetailsRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await fetchUserModuleDetails(accessToken);
      dispatch(fetchUserModuleDetailsSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(fetchUserModuleDetailsFailure(errorMessage));
      return null;
    }
  };
};
